import React from 'react'
import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../form/InputField';
import FileUpload from '../../form/FileUpload';

export interface GiftTemplateFormData {
  endDate: string | null;
  startDate: string | null;
}

interface Props {
  register: UseFormRegister<GiftTemplateFormData>;
  errors: FieldErrors<GiftTemplateFormData>;
  watch: UseFormWatch<GiftTemplateFormData>; // 👈 add watch to check values,
  image: File | null ,
setImage: React.Dispatch<React.SetStateAction<File | null>>
}

function GiftTemplateForm({ register, errors, watch ,image,setImage}: Props) {
  const { t } = useTranslation();
  const start = watch("startDate");
  console.log(start)

  return (
    <>
    <div className="grid sm:grid-cols-2 gap-4">
      {/* Start Date (optional) */}
      <InputField
        placeholder=""
        label={t("startDate")}
        register={register("startDate")}
        type="datetime-local"
        error={errors.startDate}
        defaultValue={""}
      />

      {/* End Date (optional, but must be after startDate if provided) */}
      <InputField
        placeholder=""
        label={t("endDate")}
        register={register("endDate", {
          validate: (value) =>
            !value || !start || new Date(value) > new Date(start) || t("endDate_must_be_after_startDate")
        })}
        type="datetime-local"
        error={errors.endDate}
      />
    </div>
    <div className=" mt-2">
        <FileUpload
        file={image}
        setFile={setImage}
        label={t("")}
        addText={t("add_image")}
        shape="rectangle"
        size={200}
    />
    </div>
     </>
  );
}

export default GiftTemplateForm;
